import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import "../style/pages/LoginPage.css";
import bgImage from '../assets/images/bg.jpg';
import logoImage from '../assets/images/logo.png';
import { FaUserPlus, FaEnvelope, FaLock, FaUser, FaRedo } from "react-icons/fa";

const AUTHAPP_URL = process.env.REACT_APP_AUTH_SERVICE_URL || 'http://localhost:8081';

const SignUpPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    userName: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${AUTHAPP_URL}/api/user/add`, formData);
      toast.success("Registration successful! Please check your email to verify your account.");
      navigate("/");
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Registration failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="bg-container">
        <img src={bgImage} alt="Background" className="bg-img" />
        <div className="bg-overlay"></div>
        <div className="bg-glow"></div>
      </div>

      <section className="login-content">
        <div className="glass-card">
          <div className="card-header">
            <div className="logo-box">
              <img className="logoImg" src={logoImage} alt="Logo" />
            </div>
            <h2>
               Sign Up
            </h2>
            <p className="subtitle">Join HomeBox and start organizing</p>
          </div>

          <form onSubmit={handleRegister} className="login-form">
            <div className="input-group">
              <label>Full Name</label>
              <div className="input-field">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  maxLength={255}
                />
              </div>
            </div>

            <div className="input-group">
              <label>Email Address</label>
              <div className="input-field">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  maxLength={255}
                />
              </div>
            </div>

            <div className="input-group">
              <label>Username</label>
              <div className="input-field">
                <input
                  type="text"
                  name="userName"
                  placeholder="Username"
                  value={formData.userName}
                  onChange={handleChange}
                  required
                  maxLength={50}
                />
              </div>
            </div>

            <div className="input-group">
              <label>Password</label>
              <div className="input-field password-field">
                <input
                  type="password"
                  name="password"
                  placeholder="Password (min 8 characters)"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength={8}
                  maxLength={50}
                />
              </div>
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              <span>{loading ? "Registering..." : "Sign Up"}</span>
              <div className="btn-glow"></div>
            </button>
          </form>

          <div className="card-footer">
            <p>Already have an account? <Link to="/" style={{ color: "#4f46e5", fontWeight: "bold", textDecoration: "none" }}>Sign In</Link></p>
            <p style={{ marginTop: "15px", fontSize: "0.9rem" }}>
              Didn't get the email? <button onClick={() => {
                const email = prompt("Enter your email address:");
                if (email) {
                  setLoading(true);
                  axios.post(`${AUTHAPP_URL}/api/user/resend-verification`, { email })
                    .then(() => toast.success("Verification email resent!"))
                    .catch(err => toast.error(err.response?.data?.message || "Failed to resend email"))
                    .finally(() => setLoading(false));
                }
              }} style={{ background: "none", border: "none", color: "#4f46e5", cursor: "pointer", fontWeight: "bold", padding: 0 }}>Resend Email</button>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SignUpPage;
